import axiosInstance, { createUrl } from ".";

export const getPreferences = async (params?: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.get(createUrl("/api/v1/partner/preferences"), {
      params,
    });
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};

export const updatePreferencesForId = async (id: any, data?: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.put(createUrl(`/api/v1/customer/profile/${id}/preferences`), data);
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};

export const postScrubberData = async (data?: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.post(createUrl(`/api/v1/partner/preferences`), data);
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};

export const getWpTableData = async (params?: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.get(createUrl(`/api/v1/templates/whatsapp`), { params });
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};


export const getCommunicationTableData = async (params?: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.get(createUrl(`/api/v1/templates/sms`), { params });
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};

export const createWpTableData = async (data?: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.post(createUrl(`/api/v1/templates/whatsapp`), { ...data });
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};
export const getParticularWpTableData = async (id: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.get(createUrl(`/api/v1/templates/whatsapp/${id}`));
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};


export const createCommunicationTableData = async (data?: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.post(createUrl(`/api/v1/templates/sms`), { ...data });
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};
export const getParticularCommunicationTableData = async (id: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.get(createUrl(`/api/v1/templates/sms/${id}`));
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};


export const updateParticularWpTableData = async (id: any, data?: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.patch(createUrl(`/api/v1/templates/whatsapp/${id}`), data);
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};

export const updateParticularCommunicationTableData = async (id: any, data?: any): Promise<any | []> => {
  try {
    const result: any = await axiosInstance.patch(createUrl(`/api/v1/templates/sms/${id}`), data);
    if (result.status === 200) return result?.data || [];
    return result;
  } catch (err: any) {
    console.log(">>>>>>>Error", err?.response?.data?.message[0]);
    throw err;
  } finally {
  }
};
